export default __webpack_public_path__ + "static/media/complay1.c87f0694.ico";